import { mergeAttributes } from '@giphy/js-analytics';
import React, { createContext, useContext } from 'react';
export var PingbackContext = createContext({});
// aggrigate attributes
var PingbackContextManager = function (_a) {
    var attributes = _a.attributes, children = _a.children;
    var _b = useContext(PingbackContext).attributes, parentAttributes = _b === void 0 ? {} : _b;
    return (React.createElement(PingbackContext.Provider, { value: { attributes: mergeAttributes(parentAttributes, attributes, 'layout_type') } }, children));
};
export default PingbackContextManager;
//# sourceMappingURL=pingback-context-manager.js.map